(() => {
  function i(e, t) {
    var l = e.clientHeight;
    (e.style.transitionProperty = "height, margin, padding"),
      (e.style.transitionDuration = t + "ms"),
      (e.style.boxSizing = "border-box"),
      (e.style.overflow = "hidden"),
      (e.style.height = l + "px"),
      (e.style.paddingTop = "0"),
      (e.style.paddingBottom = "0"),
      (e.style.marginTop = "0"),
      (e.style.marginBottom = "0"),
      setTimeout(function () {
        (e.style.height = "0"),
          (e.style.paddingTop = "0"),
          (e.style.paddingBottom = "0"),
          (e.style.marginTop = "0"),
          (e.style.marginBottom = "0");
      }, 10),
      setTimeout(function () {
        (e.style.display = "none"),
          e.style.removeProperty("height"),
          e.style.removeProperty("padding-top"),
          e.style.removeProperty("padding-bottom"),
          e.style.removeProperty("margin-top"),
          e.style.removeProperty("margin-bottom"),
          e.style.removeProperty("overflow"),
          e.style.removeProperty("transition-duration"),
          e.style.removeProperty("transition-property");
      }, t);
  }
  let t = (e) => {
    e &&
      e.classList.contains("collapsible-content-section") &&
      (e.querySelectorAll(".collapsible-content__toggle").forEach((o) => {
        o.addEventListener("click", () => {
          var t = o.parentElement;
          if (t.classList.contains("active"))
            t.classList.remove("active"), i(o.nextElementSibling, 300);
          else {
            t
              .closest(".collapsible-content__items")
              .querySelectorAll(".collapsible-content__item.active")
              .forEach((e) => {
                e.classList.remove("active");
              }),
              t.classList.add("active"),
              o
                .closest(".collapsible-content__items")
                .querySelectorAll(".collapsible-content__answer")
                .forEach((e) => {
                  e.previousElementSibling != o && i(e, 300);
                });
            {
              var l = o.nextElementSibling,
                t = 300;
              (l.style.overflow = "hidden"),
                (l.style.height = "0"),
                (l.style.display = "block");
              let e = l.scrollHeight;
              setTimeout(function () {
                l.style.height = e + "px";
              }, 10),
                setTimeout(function () {
                  l.style.removeProperty("overflow"),
                    l.style.removeProperty("height");
                }, t);
            }
          }
        });
      }),
      e.querySelectorAll(".collapsible-content__show--more").forEach((l) => {
        l.addEventListener("click", () => {
          var e = l.closest(".collapsible-content__content"),
            t = e.querySelectorAll(".collapsible-content__item--opacity"),
            e = e.querySelectorAll(".collapsible-content__item--hidden");
          t.forEach((e) => {
            e.classList.remove("collapsible-content__item--opacity");
          }),
            e.forEach((e) => {
              e.classList.remove("collapsible-content__item--hidden");
            }),
            l.classList.add("collapsible-content__show--hidden"),
            l.nextElementSibling.classList.remove(
              "collapsible-content__show--hidden",
            );
        });
      }),
      e.querySelectorAll(".collapsible-content__show--less").forEach((t) => {
        t.addEventListener("click", () => {
          var e = t
            .closest(".collapsible-content__content")
            .querySelectorAll(".collapsible-content__item");
          e[3].classList.add("collapsible-content__item--opacity"),
            Array.from(e)
              .slice(4)
              .forEach((e) => {
                e.classList.add("collapsible-content__item--hidden");
              }),
            t.classList.add("collapsible-content__show--hidden"),
            t.previousElementSibling.classList.remove(
              "collapsible-content__show--hidden",
            );
        });
      }));
  };
  t(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      t(e.target);
    });
})();
